<template>
  <b-sidebar :id="'sidebar-new-recording-' + classroom.id" title="Añadir grabación" sidebar-class="bb-offcanvas-panel b-sidebar-recording"
             v-on:shown="initRecordingImport"
             bg-variant="white" right backdrop-variant="dark" backdrop shadow>
    <template #default="{ hide }">
      <div class="row form-row" :class="{ 'form-group--error': $v.name.$error }">
        <label class="column col-sm-12 ng-scope form__label">Nombre de la grabación</label>
        <b-form-input :id="'recording-name-' + classroom.id" type="text" v-model="name" maxlength="255" placeholder="Título visible de la grabación"></b-form-input>
      </div>
      <div class="error" v-if="!$v.name.required || !$v.duration.minLength">El nombre es obligatorio (al menos 4 caracteres)</div>
      <div class="row form-row">
        <label class="column col-sm-12 ng-scope" bb-translate="" analytics-id="session.update.date.start-label">Inicio</label>
        <div class="picker-input date column col-sm-6">
          <b-form-datepicker
            today-button
            label-today-button="Hoy"
            label-help="Usa las flechas del teclado para navegar entre fechas"
            label-no-date-selected="-"
            :id="'recording-start-date-' + classroom.id" type="text"
            v-model="start_date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es">
          </b-form-datepicker>
        </div>
        <div class="picker-input column col-sm-6">
          <b-form-timepicker
            label-close-button="Cerrar"
            label-no-time-selected="-"
            :id="'recording-start-time-' + classroom.id" type="text"
            v-model="start_time"
            locale="es">
          </b-form-timepicker>
        </div>
      </div>
      <div class="row form-row">
        <label class="column col-sm-12 ng-scope" bb-translate="" analytics-id="session.update.date.start-label">Fin</label>
        <div class="picker-input date column col-sm-6">
          <b-form-datepicker
            today-button
            label-today-button="Hoy"
            label-help="Usa las flechas del teclado para navegar entre fechas"
            label-no-date-selected="-"
            :id="'recording-end-date-' + classroom.id" type="text"
            v-model="end_date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es">
          </b-form-datepicker>
        </div>
        <div class="picker-input column col-sm-6">
          <b-form-timepicker
            label-close-button="Cerrar"
            label-no-time-selected="-"
            :id="'recording-end-time-' + classroom.id" type="text"
            v-model="end_time"
            locale="es">
          </b-form-timepicker>
        </div>
      </div>
      <div class="row form-row" :class="{ 'form-group--error': $v.duration.$error }">
        <label class="column col-sm-12 ng-scope form__label">Duración de la grabación</label>
        <b-form-input :id="'recording-duration-' + classroom.id" v-model="duration" type="number" placeholder="Duración en segundos"></b-form-input>
      </div>
      <div class="error" v-if="!$v.duration.required || !$v.duration.numeric">La duración es obligatoria</div>
      <fieldset>
        <legend>
          <h3 class="form-label">Estado de publicación</h3>
        </legend>
        <div class="checkbox-wrap list">
          <input :id="'recording-published-' + classroom.id" type="checkbox" v-model="published">
          <label :for="'recording-published-' + classroom.id">Permitir la visualización de la grabación</label>
        </div>
      </fieldset>
      <div class="row form-row" :class="{ 'form-group--error': $v.url.$error }">
        <label class="column col-sm-12 ng-scope form__label">URL del video (MP4)</label>
        <b-form-input :id="'recording-url-' + classroom.id" type="url" v-model="url" maxlength="255" placeholder="URL donde se encuentra el video"></b-form-input>
      </div>
      <div class="error" v-if="!$v.url.required || !$v.url.url">La URL es obligatoria y debe ser válida</div>
    </template>
    <template #footer="{ hide }">
      <div class="save-buttons panel-footer">
        <div class="buttons-2 equal-buttons row">
          <div class="col-sm-6">
            <button class="button secondary cancel-button" @click="hide">Cancelar</button>
          </div>
          <div class="col-sm-6">
            <button class="button save-button" @click="updateRecording">Guardar</button>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import { minLength, required, numeric, url } from 'vuelidate/lib/validators'

export default {
  name: 'EditRecordingSidebar',
  components: {CloseIcon, LocationEnterIcon},
  mixins: [utilitiesMixin],
  props: ['classroom'],
  mounted () {
    this.$moment.locale('es')
  },
  data () {
    return {
      loading: false,
      name: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null,
      duration: null,
      published: null,
      url: null
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    duration: {
      required,
      numeric
    },
    url: {
      required,
      url
    }
  },
  methods: {
    setName (value) {
      this.name = value
      this.$v.name.$touch()
    },
    setUrl (value) {
      this.url = value
      this.$v.url.$touch()
    },
    initRecordingImport () {
      let now = window.moment()
      this.start_date = now.format('YYYY-MM-DD')
      this.start_time = now.format('HH:mm')
      now = now.add(1, 'hours')
      this.end_date = now.format('YYYY-MM-DD')
      this.end_time = now.format('HH:mm')
      this.published = true
    },
    updateRecording () {
      let vueComponent = this

      // Validación previa al envío de formulario
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      // Se importa la grabación
      let recording = {
        classroomId: this.classroom.id,
        name: this.name,
        startTime: window.moment(this.start_date + ' ' + this.start_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        endTime: window.moment(this.end_date + ' ' + this.end_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        duration: this.duration * 1000,
        published: this.published,
        url: this.url
      }
      window.axios.post('recordings/import', recording).then((response) => {
        if (response && response.status === 200) {
          vueComponent.$noty.success('La grabación se ha notificado para su importación. Si no hay errores y la url es válida aparecerá en el listado transcurridos unos minutos.', {
            timeout: 3000,
            progressBar: true
          })
          // Se reinicia el modelo y la validación, se oculta el modal y se recarga la lista
          Object.assign(this.$data, this.$options.data.call(this))
          vueComponent.$v.$reset()
          this.$root.$emit('bv::toggle::collapse', 'sidebar-new-recording-' + vueComponent.classroom.id)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/EditRecordingSidebar.vue